import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { ReactComponent as HexagonIcon } from "../new-icons/hexagon.svg";
import { ReactComponent as HexagonIconTrigger } from "../new-icons/hexagon-disable.svg";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ButtonContainer = styled.div`
    display: flex
    justify-content: center;
    position: relative;
    width: 2.886836028rem;
    height: 5rem;
    border-radius: 0.5rem/0.2rem !important;
    background: #FFFFFF;
    transition: opacity .5s;
    &:before {
        position: absolute;
        width: inherit;
        height: inherit;
        border-radius: inherit;
        background: inherit;
        content: '';
        -webkit-transform: rotate(60deg);
        transform: rotate(60deg);
    }
    &:after {
        position: absolute !important;
        width: inherit;
        height: inherit;
        border-radius: inherit;
        background: inherit;
        content: '';
        -webkit-transform: rotate(-60deg);
        transform: rotate(-60deg);
    }
`;

const IconOverlay = styled(FontAwesomeIcon)`
    color: white;
    font-size: 1.625rem;
    position: absolute;
    z-index: 1;
    margin: auto;
    top: ${props =>  props.icon.iconName === 'lock' ? '-1px' : '0'};
    left: 0;
    bottom: 0;
    right: 0;
`;

const HexagonStyle = styled.div`
    z-index: 1;
    height: 100%;
    width: fit-content;
    --color-stop: ${props => props.micPermission ? props.common.waveformColor : '#E9E9E9'};
    --color-bot: ${props => props.micPermission ? props.common.buttonColor : '#9E9E9E'};
    display: flex;
    align-items: center;
`;

const HexagonStyleTrigger = styled.div`
    z-index: 1;
    height: 100%;
    width: fit-content;
    --trigger-color1: ${props => props.common.buttonColor};
    --trigger-color2: ${props => props.common.waveformColor};
    display: flex;
    align-items: center;
`;

const SetHexagonTriggerTitle = ({ title }) => {
    return <HexagonIconTrigger title={title} />
};

const SetHexagonSmallTitle = ({ title }) => {
    return <HexagonIcon title={title} />
};
export class HexagonSmall extends Component {

    render() {
        const { common, icon, children, micPermission, title } = this.props;
        return (
            <HexagonStyle common={common} micPermission={micPermission} >
                {icon && <IconOverlay icon={icon} title={title} />}
                {children}
                <SetHexagonSmallTitle title={title} />
            </HexagonStyle>
        )
    }
}
export class HexagonSmallTrigger extends Component {

    render() {
        const { common, icon, children, title } = this.props;
        return (
            <HexagonStyleTrigger common={common}>
                {icon && <IconOverlay icon={icon} title={title} />}
                {children}
                <SetHexagonTriggerTitle title={title} />
            </HexagonStyleTrigger>
        )
    }
}

export default class Hexagon extends Component {
    static propTypes = {
        icon: PropTypes.object,
    };

    render() {
        const { icon, onClick, children, common, micPermission, title } = this.props;
        return(
            <ButtonContainer onClick={onClick}>
                <HexagonSmall common={common} icon={icon} children={children}
                              micPermission={ micPermission} title={title} />
            </ButtonContainer>
        )
    }
}
